export default __webpack_public_path__ + "static/media/headerMenu.5f36df31.svg";